export var raFormLayoutLanguageEnglish = {
    'ra-form-layout': {
        action: {
            next: 'Next',
            previous: 'Previous',
        },
        autosave: {
            last_saved_at: 'All changes saved',
            saving: 'Saving...',
            error: 'Server error, changes are not saved: %{error}',
        },
        filters: {
            apply_filters: 'Apply',
            remove_all_filters: 'Remove all filters',
            filters_button_label: 'Filters',
            source: 'Source',
            operator: 'Operator',
            value: 'Value',
            operators: {
                q: 'Contains',
                eq: 'Equals',
                neq: 'Not equals',
                gt: 'Greater than',
                lt: 'Less than',
                eq_any: 'Equals any',
                neq_any: 'Not equals any',
                boolean: 'Is true',
                inc: 'Includes',
                inc_any: 'Includes any',
                ninc_any: 'Includes none',
            },
        },
    },
};
